import Box from "@material-ui/core/esm/Box";
import Card from "@material-ui/core/esm/Card";
import CardActions from "@material-ui/core/esm/CardActions";
import CardHeader from "@material-ui/core/esm/CardHeader";
import Icon from "@material-ui/core/esm/Icon";
import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';
import useStyles from './VehicleDetailCardStyles';
export default function VehicleDetailCardSkeleton({
  hasTagNumber,
  hasTagHeader
}) {
  const {
    cardActions,
    vehicleDetailRoot,
    icon
  } = useStyles();
  return /*#__PURE__*/React.createElement(Box, {
    mt: 2,
    mb: 1
  }, hasTagHeader && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "rect",
    height: 37
  }), /*#__PURE__*/React.createElement(Box, {
    my: 2
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    width: 160,
    height: 30
  }))), /*#__PURE__*/React.createElement(Card, {
    className: vehicleDetailRoot
  }, hasTagNumber && /*#__PURE__*/React.createElement(Skeleton, {
    variant: "rect",
    height: 54
  }), /*#__PURE__*/React.createElement(CardHeader, {
    avatar: /*#__PURE__*/React.createElement(Skeleton, null, /*#__PURE__*/React.createElement(Icon, {
      className: icon
    })),
    title: /*#__PURE__*/React.createElement(Skeleton, {
      variant: "text",
      width: 140,
      height: 30
    }),
    subheader: /*#__PURE__*/React.createElement(Skeleton, {
      variant: "text",
      width: 180,
      height: 22
    })
  }), /*#__PURE__*/React.createElement(CardActions, {
    disableSpacing: true,
    className: cardActions
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    width: 160,
    height: 45
  }))));
}
VehicleDetailCardSkeleton.defaultProps = {
  hasTagNumber: false,
  hasTagHeader: false
};